import React from 'react';

// assets

// services
import GeneralService from '../../../../../services/general';

// props
import { IOrderGoodsResourceProps } from '../../../../../props/orders/orderGoods';

// components
import { Stack } from '@fluentui/react';
import Label from '../../../../typography/label';
import Text from '../../../../typography/text';
import Details from '../../../../typography/details';

interface IOrderGoodsDetailsPropertiesProps {
    orderGoods: IOrderGoodsResourceProps;
}

const OrderGoodsDetailsProperties: React.FC<IOrderGoodsDetailsPropertiesProps> = (props: IOrderGoodsDetailsPropertiesProps) => {
    const { orderGoods } = props;

    return <Stack tokens={{ childrenGap: 15 }} styles={{ root: { marginTop: 10 } }}>
        <Details title={'Goods'} text={orderGoods.goods.name || "-"} />
        {(orderGoods.notes || "").trim() !== "" ? <Details title={'Notes'} text={orderGoods.notes || "-"} /> : null}
        <Details title={'Quantity'} text={`${GeneralService.getNumberWithSeparator(Number(orderGoods.quantityAmount))} ${orderGoods.goods.quantityUnit || ""}`} />
        <Stack className={'divider'}></Stack>
        <Label size={'small'}>Pricing Details</Label>
        <Stack>
            <Details title={'Price'} text={`Rp. ${GeneralService.getNumberWithSeparator(orderGoods.price || "0")}`} />
            <Stack horizontal tokens={{childrenGap: 5}}>
                {orderGoods.includePPn ? <Text size={'small'} className={'color-green'}>(include PPn)</Text> : null}
                {orderGoods.includePPh ? <Text size={'small'} className={'color-green'}>(include PPh)</Text> : null}
                {!orderGoods.includePPn ? <Text size={'small'} className={'color-red'}>(exclude PPn)</Text> : null}
                {!orderGoods.includePPh ? <Text size={'small'} className={'color-red'}>(exclude PPh)</Text> : null}
            </Stack>
        </Stack>
        <Stack horizontal tokens={{childrenGap: 20}}>
            <Details title={`PPn (${orderGoods.ppnPercentage}%)`} text={`Rp. ${GeneralService.getNumberWithSeparator(Number(orderGoods.ppn))}`} style={{width: '50%'}} />
            <Details title={`PPh (${orderGoods.pphPercentage}%)`} text={`Rp. ${GeneralService.getNumberWithSeparator(Number(orderGoods.pph))}`} style={{width: '50%'}} />
        </Stack>
        <Stack horizontal tokens={{childrenGap: 20}}>
            <Details title={`Price (inc. PPn & PPh)`} text={`Rp. ${GeneralService.getNumberWithSeparator(orderGoods.totalPrice)}`} style={{width: '50%'}} />
            <Details title={`Invoice price (total price - PPh)`} text={`Rp. ${GeneralService.getNumberWithSeparator(orderGoods.invoicePrice)}`} style={{width: '50%'}} />
        </Stack>
    </Stack>
};

export default OrderGoodsDetailsProperties;
